import { render, staticRenderFns } from "./PannelloCensimenti.vue?vue&type=template&id=6dac05e2&scoped=true&lang=pug&"
import script from "./PannelloCensimenti.vue?vue&type=script&lang=ts&"
export * from "./PannelloCensimenti.vue?vue&type=script&lang=ts&"
import style0 from "./PannelloCensimenti.vue?vue&type=style&index=0&id=6dac05e2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dac05e2",
  null
  
)

export default component.exports